window.addEventListener('DOMContentLoaded', () => {

  let pdqWidgetCounter = 0;

  const pdqWidgetInterval = setInterval(() => {

    const pdqWidget = document.querySelector('pdqproductpromise');

    if (!!pdqWidget) {

      let productAvailable = pdqWidget.closest('.product__info-wrapper').querySelector('.product__ctas')

      if (!!!productAvailable) pdqWidget.style.display = 'none';

      const previousElement = document.querySelector('[id*="js-product-form__error-message--"]');

      previousElement?.insertAdjacentElement('afterend', pdqWidget.parentElement);
      clearInterval(pdqWidgetInterval)

    }
    else if (!!!pdqWidget && pdqWidgetCounter < 150) pdqWidgetCounter += 1
    else clearInterval(pdqWidgetInterval)

  }, 50);

})
